export default {
    controller: 'loadingController',
    template: require('../views/loading.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/auth/components/loading.component.js